/**
 * What to show for an attendance row's status.
 *
 * While someone is punched out before their shift has ended, the stored status
 * is not settled yet: a lunch break and going home look the same until the
 * shift is over, and the early-leave rule has already marked the day Half Day.
 * So until then the row reads "Out since 13:00" rather than a status that may
 * change the moment they punch back in. lastPunch and shiftEndsAt come from the
 * server (server/models/Attendance.js); older rows have neither.
 */
export const isOutNow = (log, now = new Date()) =>
    log?.lastPunch === 'OUT'
    && Boolean(log.checkOut)
    && Boolean(log.shiftEndsAt)
    && now < new Date(log.shiftEndsAt);

const clock = (value) =>
    new Date(value).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

export const attendanceStatusLabel = (log, now = new Date()) =>
    isOutNow(log, now) ? `Out since ${clock(log.checkOut)}` : log?.status;
